/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PurchaseRateDTO interface.
 */
export function instanceOfPurchaseRateDTO(value) {
    return true;
}
export function PurchaseRateDTOFromJSON(json) {
    return PurchaseRateDTOFromJSONTyped(json, false);
}
export function PurchaseRateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rateId': json['rateId'] == null ? undefined : json['rateId'],
        'carrierCompany': json['carrierCompany'] == null ? undefined : json['carrierCompany'],
        'carrierService': json['carrierService'] == null ? undefined : json['carrierService'],
        'deliveryPeriod': json['deliveryPeriod'] == null ? undefined : json['deliveryPeriod'],
        'price': json['price'] == null ? undefined : json['price'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'carrierPrice': json['carrierPrice'] == null ? undefined : json['carrierPrice'],
        'serviceFees': json['serviceFees'] == null ? undefined : json['serviceFees'],
        'insuranceFee': json['insuranceFee'] == null ? undefined : json['insuranceFee'],
        'customsFees': json['customsFees'] == null ? undefined : json['customsFees'],
        'otherFees': json['otherFees'] == null ? undefined : json['otherFees'],
        'discountAmount': json['discountAmount'] == null ? undefined : json['discountAmount'],
        'requiresBuyerEmail': json['requiresBuyerEmail'] == null ? undefined : json['requiresBuyerEmail'],
    };
}
export function PurchaseRateDTOToJSON(json) {
    return PurchaseRateDTOToJSONTyped(json, false);
}
export function PurchaseRateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'rateId': value['rateId'],
        'carrierCompany': value['carrierCompany'],
        'carrierService': value['carrierService'],
        'deliveryPeriod': value['deliveryPeriod'],
        'price': value['price'],
        'currency': value['currency'],
        'carrierPrice': value['carrierPrice'],
        'serviceFees': value['serviceFees'],
        'insuranceFee': value['insuranceFee'],
        'customsFees': value['customsFees'],
        'otherFees': value['otherFees'],
        'discountAmount': value['discountAmount'],
        'requiresBuyerEmail': value['requiresBuyerEmail'],
    };
}
